import styled from 'styled-components';

export const TextWrapper = styled.div`
  font-size: 11px;
  padding: 5px;
  color: #31394d;
  font-weight: 500;
`;

export const AlertScoreWrapper = styled.div`
  font-style: normal;
  font-size: 12px;
  line-height: 12px;
  color: #31394d;
  display: flex;
  align-items: center;
  padding-top: 3px;

  .ant-progress-line {
    width: auto;
    margin-right: 5px;
    margin-left: 3px;
  }

  .ant-progress-inner {
    width: 50px;

    .ant-progress-bg {
      height: 8px !important;
    }
  }

  p {
    margin: 2px 0 0;
    font-weight: 300;
    font-size: 9px;
    line-height: 16px;

    b {
      font-weight: bold;
      font-size: 12px;
    }
  }
`;

export const ProgressText = styled.div`
  font-size: 11px;
  padding: 0;
  margin: 0;
  color: #31394d;
  font-weight: 500;
`;

export const NotStarted = styled.div`
  font-size: 11px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  color: #748aa1;
`;

export const InProgress = styled.div`
  font-size: 11px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  color: #eb9229;
`;

export const Complete = styled.div`
  font-size: 11px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  color: #48c93d;
`;

export const LowQuality = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 20px;
  color: #ffffff;
  padding: 1px 8px;
  width: 90px;
  height: 22px;
  background: #e29840;
  border-radius: 20px;
  text-align: center;
`;
export const GoodQuality = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 20px;
  color: #ffffff;
  padding: 1px 8px;
  width: 90px;
  height: 22px;
  background: #0c8ed7;
  border-radius: 20px;
  text-align: center;
`;
export const HighQuality = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 20px;
  color: #ffffff;
  padding: 1px 8px;
  width: 90px;
  height: 22px;
  background: #48c93d;
  border-radius: 20px;
  text-align: center;
`;
export const EllipsisPop = styled.div`
  font-size: 11px;
  padding: 0;
  margin: 0;
  font-weight: 500;
`;
